/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateRequest
 */
export interface CreateRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateRequest
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateRequest
     */
    password?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateRequest
     */
    name?: string | null;
}

export function CreateRequestFromJSON(json: any): CreateRequest {
    return CreateRequestFromJSONTyped(json, false);
}

export function CreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': !exists(json, 'email') ? undefined : json['email'],
        'password': !exists(json, 'password') ? undefined : json['password'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function CreateRequestToJSON(value?: CreateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'password': value.password,
        'name': value.name,
    };
}


